const MessageSvg = (props) => {
  return (
    <svg width={props.width} height={props.height} viewBox="0 0 1000 1000">
      <defs>
        <clipPath id="clip-Custom_Size_1">
          <rect width="1000" height="1000" />
        </clipPath>
      </defs>
      <g
        id="Custom_Size_1"
        data-name="Custom Size – 1"
        clip-path="url(#clip-Custom_Size_1)"
      >
        <g id="letterCap" transform="translate(145 154.123)">
          <g id="Group_6" data-name="Group 6">
            <g id="top" transform="translate(4.528)">
              <g
                id="letterCap-2"
                data-name="letterCap"
                transform="translate(0 2.497)"
              >
                <path
                  id="Path_10"
                  data-name="Path 10"
                  d="M364.531-76.327a7.839,7.839,0,0,1,3.109-1.109,9.3,9.3,0,0,1,3.563.891L692.338,146.807l41.3,28.723L371.994,327.97l-.934.081L3.528,176.812Z"
                  transform="translate(-3.528 77.442)"
                  fill="#d8d8d8"
                />
              </g>
              <path
                id="Path_1"
                data-name="Path 1"
                d="M1050.515,449.525a1.3,1.3,0,0,1-.745-.234L688.851,197.937a6.545,6.545,0,0,0-7.476.013L323.054,449.289a1.305,1.305,0,1,1-1.5-2.137l358.32-251.34a9.164,9.164,0,0,1,10.467-.017l360.919,251.354a1.305,1.305,0,0,1-.747,2.376Z"
                transform="translate(-320.633 -194.162)"
                fill="#3f3d56"
              />
            </g>
          </g>
          <g id="undraw_mail_sent_re_0ofv" transform="translate(-2.936 -1)">
            <path
              id="Path_3"
              data-name="Path 3"
              d="M530.585,654.393H361.66a7.892,7.892,0,1,1,0-15.784H530.585a7.892,7.892,0,0,1,0,15.784Z"
              transform="translate(-303.174 -58.589)"
              fill="#2978b5"
            />
            <path
              id="Path_4"
              data-name="Path 4"
              d="M422.267,628.393H361.66a7.892,7.892,0,0,1,0-15.784h60.606a7.892,7.892,0,0,1,0,15.784Z"
              transform="translate(-303.174 -66.52)"
              fill="#2978b5"
            />
            <g id="Letter" transform="translate(160.52 220)">
              <g id="Group_4" data-name="Group 4">
                <path
                  id="Path_5"
                  data-name="Path 5"
                  d="M654.126,591.6a9.867,9.867,0,0,1-3.744-.733L439.5,503.366V229.472a9.146,9.146,0,0,1,9.135-9.135H853.2a9.146,9.146,0,0,1,9.135,9.135V503.556l-.4.169-203.952,87.1A9.937,9.937,0,0,1,654.126,591.6Z"
                  transform="translate(-439.5 -220.337)"
                  fill="#fff"
                  stroke="#707070"
                  stroke-width="1"
                />
                <path
                  id="Path_8"
                  data-name="Path 8"
                  d="M629.8,506.822a35.887,35.887,0,0,1-21.593-7.173l-.386-.29L526.5,437.1a36.128,36.128,0,1,1,43.946-57.355l52.672,40.388L747.591,257.8a36.127,36.127,0,0,1,50.653-6.686l-.774,1.051.794-1.035a36.169,36.169,0,0,1,6.686,50.653L658.541,492.722a36.142,36.142,0,0,1-28.742,14.1Z"
                  transform="translate(-417.28 -221.224)"
                  fill="#2978b5"
                  stroke="#707070"
                  stroke-width="1"
                />
              </g>
            </g>
            <g id="bottom" transform="translate(2.936 254.877)">
              <g id="Path_9" data-name="Path 9" fill="#fff">
                <path
                  d="M 735.5 340.5 L 0.5 340.5 L 0.5 0.7463636994361877 L 372.3219909667969 153.7257232666016 L 372.5146484375 153.8049926757812 L 372.70654296875 153.7240905761719 L 735.5 0.7534649968147278 L 735.5 340.5 Z"
                  stroke="none"
                />
                <path
                  d="M 1 1.492767333984375 L 1 340 L 735 340 L 735 1.506927490234375 L 372.5169982910156 154.3466339111328 L 372.1318054199219 154.1881866455078 L 1 1.492767333984375 M 0 0 L 372.5122680664062 153.2633666992188 L 736 0 L 736 341 L 0 341 L 0 0 Z"
                  stroke="none"
                  fill="#707070"
                />
              </g>
              <path
                id="Path_11"
                data-name="Path 11"
                d="M530.585,654.393H361.66a7.892,7.892,0,1,1,0-15.784H530.585a7.892,7.892,0,0,1,0,15.784Z"
                transform="translate(-306.11 -381.329)"
                fill="#2978b5"
              />
              <path
                id="Path_12"
                data-name="Path 12"
                d="M422.267,628.393H361.66a7.892,7.892,0,0,1,0-15.784h60.606a7.892,7.892,0,0,1,0,15.784Z"
                transform="translate(-306.11 -389.26)"
                fill="#2978b5"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default MessageSvg;
